import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const MY_TEAM: AppRouteRecordRaw = {
  path: '/my-team',
  name: 'my-team',
  component: DEFAULT_LAYOUT,
  redirect: '/my-team/list',
  meta: {
    locale: 'menu.myTeam',
    requiresAuth: true,
    icon: 'icon-user-group',
    order: 1,
    hideChildrenInMenu: true,
    activeMenu: 'my-team',
  },
  children: [
    {
      path: 'list',
      name: 'MyTeamList',
      component: () => import('@/views/team/myTeam.vue'),
      meta: {
        locale: 'menu.myTeam',
        requiresAuth: true,
        roles: ['AreaAdmin', 'TeamLeader'],
      },
    },
  ],
};
export default MY_TEAM;
